import React, { useState } from "react";
import { useAppDispatch } from "../../../app/features/store/store";
import { toast } from "react-toastify";
import { AddEventTypeRequest } from "../../../app/models/requestModels/eventTypeRequest";
import { updateUserTokenToInvalid } from "../../../app/features/login/loginSlice";
import getAxiosError from "../../../app/api/axiosError";
import SubmitModal from "../../../components/common/modalPopup/SubmitModal";
import { Box, Grid, TextField } from "@mui/material";
import { addEventType } from "../../../app/features/eventType/eventTypeSlice";

interface AddEventTypeModalProps {
  closeAddEventTypeModal: CallableFunction;
  onCompleted: CallableFunction;
}

function AddEventTypeModel(
  name: string,
  category: string,
  description: string
): AddEventTypeRequest {
  return {
    name: name,
    category: category,
    description: description,
  };
}

const AddEventTypeModal = ({
  closeAddEventTypeModal,
  onCompleted,
}: AddEventTypeModalProps) => {
  const dispatch = useAppDispatch();

  // ***** States *****
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");

  // ***** Handlers *****
  const handleSubmit = async () => {
    try {
      if (name.length === 0) {
        toast.error("Event name is required");
        return false;
      }
      if (category.length === 0) {
        toast.error("Category is required");
        return false;
      }
      const model = AddEventTypeModel(name, category, description);
      const response = await dispatch(addEventType(model)).unwrap();
      if (response.isSuccess) {
        toast.success(response.message!, {
          toastId: "addMiddleMileSuccess",
        });
        onCompleted();
      } else {
        toast.error(response.message!, {
          toastId: "addMiddleMileError",
        });
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "addMiddleMileException",
      });
    }
    return true;
  };

  return (
    <>
      <SubmitModal
        title="Add Event Type"
        asyncOperation={handleSubmit}
        closeSubmitModal={closeAddEventTypeModal}
        allowSubmit={true}
        size="lg"
        isLoading={false}
        submitButtonName="Save"
        closeModalAfterSubmit={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="eventName"
                label="Event Name"
                name="eventName"
                size="small"
                fullWidth
                required
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="category"
                label="Category"
                name="category"
                size="small"
                fullWidth
                required
                value={category}
                onChange={(event) => setCategory(event.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                margin="normal"
                id="description"
                label="Description"
                name="description"
                size="small"
                fullWidth
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </Grid>
          </Grid>
        </Box>
      </SubmitModal>
    </>
  );
};

export default AddEventTypeModal;
